import { beginLogout } from './logout-state';
import { clearOdpLoginMarker } from './odp-helper';

/**
 * Full site-user logout: clears the back-end bridge session (`CpgSiteUser`) and the auth0-spa-js
 * token cache, then navigates to the hosted logout. Shared by the cic-nav sign-out and the
 * idle-timeout so both tear the session down the same way.
 *
 * When passed as SessionTimeout's `logout` prop, the component calls this INSTEAD of navigating to
 * `logoutUrl`, so this owns the redirect.
 */
export const performSiteUserLogout = async (
	logout: (options?: any) => Promise<void>,
	logoutUrl: string,
): Promise<void> => {
	// Flag first and synchronously so any login gate stops forcing a re-login.
	beginLogout();
	// Drop the ODP session marker so signing back in reports a fresh login.
	clearOdpLoginMarker();
	// Clear the server-side site-user cookie.
	try {
		await fetch('/api/auth/site-session', { method: 'DELETE', credentials: 'same-origin' });
	} catch { /* non-fatal */ }
	// Clear the auth0-spa-js token cache (localStorage) WITHOUT a redirect so it can't re-hydrate.
	try {
		await logout({ openUrl: false });
	} catch { /* non-fatal */ }
	// Continue to the hosted logout (clears the Auth0 SSO + signin session).
	window.location.replace(logoutUrl);
};
